import { AnimatedCircularProgressBar } from '@talentmesh/ui/components/animated-circular-progress-bar';
import type { PercentileLevel } from '@talentmesh/utils';

interface ResultsTalentScoreCircularProgressProps {
    level: PercentileLevel;
    progress?: number;
}

function ResultsTalentScoreCircularProgress({ level, progress }: ResultsTalentScoreCircularProgressProps) {
    return (
        <AnimatedCircularProgressBar value={progress} level={level} className="size-[50px] text-base font-semibold" />
    );
}

export default ResultsTalentScoreCircularProgress;
